import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  saveLoading: false,
  criticidad: null,
  criticidadError: "",
  formError: "",
};

export default function CriticidadReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_CRITICIDAD:
      return { ...state, loading: action.payload };
    case actions.SAVE_LOADING_CRITICIDAD:
      return { ...state, saveLoading: action.payload };
    case actions.GET_CRITICIDAD:
      return { ...state, criticidad: action.payload };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.CRITICIDAD_FAIL:
      return { ...state, criticidadError: action.payload };
    default:
      return state;
  }
}
